import { SystemStyleObject } from '@chakra-ui/react';
import { ColorMode } from '@allergan-data-labs/alle-elements-core';
import { getActionListItemStyles } from '@allergan-data-labs/alle-elements-action-menu';

export const getOverflowIconStyles = (
  colorMode: ColorMode
): SystemStyleObject => ({
  color: `${colorMode}.Icon/Neutral/Support`,
});

export const getActionListItemLinkStyles = (
  colorMode: ColorMode
): SystemStyleObject => {
  return {
    // CALLOUT - If we don't get these styles we end up overwriting them
    ...getActionListItemStyles(colorMode),
    a: {
      color: `${colorMode}.Text/Neutral/Default`,
      _hover: {
        textDecoration: 'none',
        color: `${colorMode}.Text/Neutral/Default`,
      },
    },
  };
};
